<template>
    <div>
        <div class="login-wrap" id="home">
            <div class="Loading__bar___21yOt"
                 style="background: rgb(255,255,255); width: 0%;height:2px;transition: width .35s;position: fixed;top:0">
            </div>
            <div class="box">
                <div class="title"><a href="https://www.ishouping.com"><img class="logo"
                                                                            src="../assets/img/spzxlogo.png" alt=""></a>
                </div>
            </div>
            <div class="box_card">
                <div class="flex_width">
                    <div class="rightbox">
                        <h2>商家登录</h2>

                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
                                 class="demo-ruleForm">
                            <el-form-item prop="username">
                                <el-input v-model="ruleForm.username" placeholder="请输入用户名/手机号码">
                                    <i slot="prefix" class="icon el-input__icon el-icon-user"></i>
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="password">
                                <el-input type="password" placeholder="请输入密码" v-model="ruleForm.password"
                                          @keyup.enter.native="submitForm('ruleForm')">
                                    <i slot="prefix" class="icon el-input__icon el-icon-pass"></i>
                                </el-input>
                            </el-form-item>
                            <div class="submit">
                                <el-row style="display: flex;display: -webkit-flex;justify-content: space-between;-webkit-justify-content: space-between;">
                                    <el-button type="primary" @click="submitReg()">注册</el-button>
                                    <el-button type="primary" class="login_first" @click="submitForm('ruleForm')">登录</el-button>
                                </el-row>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <footer class="width footer">
                <div class="fiex_width footer_black">
                    <div class="top_nav">
                        <ul class="nav_footer">
                            <li style="font-weight: 600;font-size: 15px;color: #5d6369 !important;">我是商家</li>
                            <li><a target="_blank" href="/">商家登录</a></li>
                            <li><a target="_blank" href="/reg">注册商家</a></li>
                            <li><a target="_blank" href="/">发布商品</a></li>
                        </ul>
                        <ul class="nav_footer contact_footer" style="margin-left: 20px;width: 130px;">
                            <li style="font-weight: 600;font-size: 15px;color: #5d6369 !important;">热门行业</li>
                            <template v-for="h in hot">
                                <li><a target="_blank" :href="'https://www.ishouping.com/'+h.nick+'/'">{{h.c_name}}</a>
                                </li>
                            </template>
                        </ul>
                        <ul class="nav_footer contact_footer" style="margin-left: 20px;width: 130px;">
                            <li style="font-weight: 600;font-size: 15px;color: #5d6369 !important;">好货热销</li>
                            <template v-for="g in good">
                                <li><a target="_blank" :href="'https://www.ishouping.com/'+g.nick+'/'">{{g.c_name}}</a>
                                </li>
                            </template>
                        </ul>
                        <ul class="nav_footer contact_footer" style="margin-left: 20px;width: 130px;">
                            <li style="font-weight: 600;font-size: 15px;color: #5d6369 !important;">火爆交易</li>
                            <template v-for="t in transact">
                                <li><a target="_blank" :href="'https://www.ishouping.com/'+t.nick+'/'">{{t.c_name}}</a>
                                </li>
                            </template>
                        </ul>
                        <ul class="nav_footer contact_footer lxwm" style="margin-left: 20px;width: 190px;">
                            <li style="font-weight: 600;font-size: 15px;color: #5d6369 !important;">联系我们</li>
                            <li><a :href="'tel:'+web_site.hotline"><span style="width: 60px;">业务咨询：</span><span
                                    style=" margin-top: -4px;white-space:nowrap;color:#ff5400;font-size: 18px;font-weight: 600;">{{web_site.hotline}}</span></a>
                            </li>
                            <li><a :href="'tel:'+web_site.hotline_after"><span style="width: 60px;">售后服务：</span><span
                                    style=" margin-top: -4px;white-space:nowrap;color:#ff5400;font-size: 18px;font-weight: 600;">{{web_site.hotline_after}}</span></a>
                            </li>
                            <li><a :href="'mailto:'+web_site.email"><span>邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：</span>{{web_site.email}}</a>
                            </li>
                        </ul>
                        <div class="footer_img">
                            <img src="../assets/img/ewmimg.png" alt="">
                            <br>
                            <p>扫描二维码,了解更多</p>
                        </div>
                    </div>
                    <div class="bottom_nav">
                        <div>{{web_site.copy_right}}</div>
                        <div>
                            <a style="display: inline-block;padding-right: 7px;"
                               :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+web_site.ipc1"
                               target="_blank" rel="nofollow" title="公安备案"><img class="web-warn"
                                                                                src="../assets/img/beian.png"
                                                                                alt="公安备案"></a>公安备案 苏公网安备{{web_site.ipc1}}
                            <a rel="nofollow" target="_blank" href="http://www.beian.miit.gov.cn">{{web_site.ipc2}}</a>
                            <a rel="nofollow" target="_blank" href="http://www.miitbeian.gov.cn">{{web_site.ipc3}}</a>&nbsp;&nbsp;
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    </div>
</template>
<style>
</style>
<script>
    import "../assets/css/login.css";
    import {mapMutations} from 'vuex'

    export default {
        data: function () {
            return {
                web_site: {
                    hotline: '', email: '', copy_right: '', ipc1: '', ipc2: '', ipc3: '', hotline_after: ''
                },
                transact: {},
                hot: {},
                good: {},
                ruleForm: {
                    username: "",
                    password: ""
                },
                rules: {
                    username: [
                        {
                            required: true,
                            message: "请输入用户名",
                            trigger: "blur"
                        },
                        {
                            min: 3,
                            message: "用户名必须大于3位",
                            trigger: "blur,change"
                        }
                    ],
                    password: [
                        {required: true, message: "请输入密码", trigger: "blur"},
                        {
                            min: 6,
                            message: "密码必须大于6位",
                            trigger: "blur,change"
                        }
                    ]
                }
            };
        },
        mounted() {
            document.title = '商家登录-首屏好商贸';
            this.getInfo();
        },
        methods: {
            ...mapMutations('navTabs', [
                'closeAllTab'
            ]),
            getInfo(){
                let that = this;
                this.$ajax.get('admin/Login/website').then(function (res) {
                    if (res.data.error === 0) {
                        that.web_site = res.data.data.web_site
                        that.transact = res.data.data.transact
                        that.hot = res.data.data.hot
                        that.good = res.data.data.good
                    }
                })
            },
            submitForm(formName) {
                const self = this;
                self.$refs[formName].validate(valid => {
                    if (valid) {
                        self.$ajax
                            .post("/admin/Login/login", self.ruleForm)
                            .then(function (res) {
                                if (res.data.error === 0) {
                                    localStorage.setItem("org_b_name", res.data.data.b_name);
                                    localStorage.setItem("org_b_id", res.data.data.b_id);
                                    self.closeAllTab();
                                    self.$router.push("/index");
                                } else {
                                    self.$message.error(res.data.message);
                                }
                            })
                            .catch(function (err) {
                                self.$message("网络错误！请联系管理员");
                            });
                    } else {
                        return false;
                    }
                });
            },
            submitReg(){
                this.$router.push("/reg");
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/views/Login.vue